import { Injectable } from "@angular/core";
import { Http, RequestOptions } from "@angular/http";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { AuthHeaderService } from "../views/authheader.service";
import { throwError as observableThrowError, Observable } from "rxjs";
@Injectable({
  providedIn: "root",
})
export class DwollafundingsourceService {
  dwollaurl: string;
  constructor(private http: Http, private _headerService: AuthHeaderService) {
    this.dwollaurl = environment.dwollaurl;
  }
  SendForm(pageFilters: any) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(this.dwollaurl + "/fundingsource", pageFilters, options)
      .pipe(
        map((response) => response.json()),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  getDwollaFundingSourceData(dwollaCustomerId) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .get(this.dwollaurl + "/fundingsource/" + dwollaCustomerId, options)
      .pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  getDwollaFundingSourceAllData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.dwollaurl + "/fundingsource/", options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getDwollaData(dwollaCustomerId: String) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .get(this.dwollaurl + "/fundingsource/" + dwollaCustomerId, options)
      .pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  verifyMicroDeposits(pageFilters: any) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(
        this.dwollaurl + "/fundingsource/verifymicrodeposits/",
        pageFilters,
        options
      )
      .pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  initiateMicroDeposits(pageFilters: any) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(
        this.dwollaurl + "/fundingsource/initiatemicrodeposits/",
        pageFilters,
        options
      )
      .pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  setReceiptDefault(fundingsource: any, id: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(
        this.dwollaurl + "/fundingsource/receiptdefault/" + id,
        fundingsource,
        options
      )
      .pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  setPaymentDefault(fundingsource: any, id: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(
        this.dwollaurl + "/fundingsource/paymentdefault/" + id,
        fundingsource,
        options
      )
      .pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  receiptPosting(fundingsource: any, id: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(this.dwollaurl + "/fundingsource/receiptposting/" + id, fundingsource, options)
      .pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
  paymentPosting(fundingsource: any, id: string) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http
      .post(this.dwollaurl + "/fundingsource/paymentposting/" + id, fundingsource, options)
      .pipe(
        map((response) => (response.json().data ? [] : response.json())),
        catchError((error: Response) => {
          return observableThrowError(error);
        })
      );
  }
}
